const factoids = [
  {
    stat: "33%",
    desc: "The astonishing rate at which data center capacity is growing between 2023 and 2030",
    source: "AI Strategems",
    link: "https://aistratagems.com/",
    solution: "ai"
  },
  {
    stat: "72%",
    desc: "Of businesses cite downtime due to cable management and installation errors",
    source: "Cockroach Labs",
    link: "https://www.cockroachlabs.com/",
    solution: "ai"
  },
  {
    stat: "28.3%",
    desc: "The AI data center market is growing at more than double the growth rate of traditional data centers",
    source: "Grandview Research",
    link: "https://www.grandviewresearch.com/",
    solution: "ai"
  },
  {
    stat: "50%+",
    desc: "The number of data center operators citing skilled labor shortages as their top barrier to scaling AI infrastructure",
    source: "Uptime Institute",
    link: "https://uptimeinstitute.com/",
    solution: "ai"
  },

  {
    stat: "4X",
    desc: "Improvement in hardware compute performance",
    source: "Forbes",
    link: "https://www.forbes.com/sites/tiriasresearch/2023/05/12/generative-ai-breaks-the-data-center-data-center-infrastructure-and-operating-costs-projected-to-increase-to-over-76-billion-by-2028?sh=755f441c7c15",
    solution: "datacenter"
  },
  {
    stat: "6-10mo",
    desc: "AI’s computational power is doubling every 6-10 months",
    source: "Time",
    link: "https://time.com/6255952/ai-impact-chatgpt-microsoft-google",
    solution: "datacenter"
  },
  {
    stat: "50X",
    desc: "Increase in processing workloads",
    source: "Forbes",
    link: "https://www.forbes.com/sites/tiriasresearch/2023/05/12/generative-ai-breaks-the-data-center-data-center-infrastructure-and-operating-costs-projected-to-increase-to-over-76-billion-by-2028?sh=755f441c7c15",
    solution: "datacenter"
  },
  {
    stat: "212X",
    desc: "Increase in data center power consumption",
    source: "Forbes",
    link: "https://www.forbes.com/sites/tiriasresearch/2023/05/12/generative-ai-breaks-the-data-center-data-center-infrastructure-and-operating-costs-projected-to-increase-to-over-76-billion-by-2028?sh=755f441c7c15",
    solution: "datacenter"
  },

  {
    stat: "2 years",
    desc: "Global bandwidth is doubling at approximately this rate",
    source: "Cisco",
    link: "https://www.cisco.com/",
    solution: "central-office"
  },
  {
    stat: "74%",
    desc: "The percentage of MSOs investing in fiber-rich architecture to support multi-gig services",
    source: "Light Reading",
    link: "https://www.lightreading.com/",
    solution: "central-office"
  },
  {
    stat: ">50%",
    desc: "Over half of telecom operators plan to virtualize headend functions",
    source: "Heavy Reading",
    link: "https://www.heavyreading.com/",
    solution: "central-office"
  },
  {
    stat: ">70%",
    desc: "Of telecom providers are actively upgrading central offices to support higher bandwidths and AI",
    source: "Fiber Broadband Association",
    link: "https://fiberbroadband.org/",
    solution: "central-office"
  },

  {
    stat: "2 years",
    desc: "Global bandwidth is doubling at approximately this rate",
    source: "Cisco",
    link: "https://www.cisco.com/",
    solution: "outside-plant"
  },
  {
    stat: "74%",
    desc: "The percentage of MSOs investing in fiber-rich architecture to support multi-gig services",
    source: "Light Reading",
    link: "https://www.lightreading.com/",
    solution: "outside-plant"
  },
  {
    stat: ">50%",
    desc: "Over half of telecom operators plan to virtualize headend functions",
    source: "Heavy Reading",
    link: "https://www.heavyreading.com/",
    solution: "outside-plant"
  },
  {
    stat: ">70%",
    desc: "Of telecom providers are actively upgrading central offices to support higher bandwidths and AI",
    source: "Fiber Broadband Association",
    link: "https://fiberbroadband.org/",
    solution: "outside-plant"
  },

  {
    stat: "$25B",
    desc: "The size of the global FTTX market by 2027",
    source: "Allied Market Research",
    link: "https://www.alliedmarketresearch.com/",
    solution: "fttx"
  },
  {
    stat: "60%",
    desc: "Percentage of new broadband deployments in the MDU",
    source: "Fiber Broadband Association",
    link: "https://fiberbroadband.org/",
    solution: "fttx"
  },
  {
    stat: "77 million",
    desc: "US homes passed with fiber connections in 2023",
    source: "NTCA",
    link: "https://www.ntca.org/",
    solution: "fttx"
  },
  {
    stat: "70%",
    desc: "Of consumers say fiber is the most desirable internet option",
    source: "Pew Research Center",
    link: "https://www.pewresearch.org/",
    solution: "fttx"
  },

  {
    stat: "23%",
    desc: "Nearly a quarter of rural Americans still lacked access to broadband-speed internet",
    source: "FCC",
    link: "https://www.fcc.gov/",
    solution: "rural-broadband"
  },
  {
    stat: "$42.45B",
    desc: "BEAD program allocations for fiber-rich MSO architectures, supporting multi-gig services",
    source: "Light Reading",
    link: "https://www.lightreading.com/",
    solution: "rural-broadband"
  },
  {
    stat: "<1ms",
    desc: "Fiber broadband has the lowest average latency of any internet technology, under one millisecond",
    source: "Ookla",
    link: "https://www.ookla.com/",
    solution: "rural-broadband"
  },
  {
    stat: "4%",
    desc: "Rural areas with fiber access have a higher employment growth rate of 4%",
    source: "Fiber Broadband Association",
    link: "https://fiberbroadband.org/",
    solution: "rural-broadband"
  },

  {
    stat: "$365B",
    desc: "Projected growth in wireless connectivity from $118B to 2033",
    source: "Global Growth Insights",
    link: "https://www.globalgrowthinsights.com/",
    solution: "wireless"
  },
  {
    stat: "60%",
    desc: "Of annual data traffic growth from the top 30 countries will be from 5G, eclipsing 4k exabytes by 2027",
    source: "Ericsson Mobility Report",
    link: "https://www.ericsson.com/en/reports-and-papers/mobility-report",
    solution: "wireless"
  },
  {
    stat: "30%",
    desc: "5G deployments are driving more investment in backhaul technologies growth",
    source: "Global Growth Insights",
    link: "https://www.globalgrowthinsights.com/",
    solution: "wireless"
  },
  {
    stat: "75%",
    desc: "Percentage of wireless operators integrating AI automation for backhaul efficiency and lower latency",
    source: "Ethernet Alliance",
    link: "https://ethernetalliance.org/",
    solution: "wireless"
  },

  {
    stat: "6% YoY",
    desc: "Global enterprise network spending growth",
    source: "Fierce Networks",
    link: "https://www.fierce-network.com/",
    solution: "enterprise"
  },
  {
    stat: "70%",
    desc: "Of IT leaders prioritize fiber-based LAN updates to support AI",
    source: "McKinsey",
    link: "https://www.mckinsey.com/",
    solution: "enterprise"
  },
  {
    stat: "60%",
    desc: "Of enterprises are transitioning to fiber-rich networks for AI, cloud computing, and high-speed data",
    source: "Fiber Broadband Association",
    link: "https://fiberbroadband.org/",
    solution: "enterprise"
  },
  {
    stat: "24-fiber",
    desc: "Bundled fiber cables are increasing density in LAN environments",
    source: "Fierce Networks",
    link: "https://www.fierce-network.com/",
    solution: "enterprise"
  },

  {
    stat: "~5%",
    desc: "Global medical imaging market growth rate through 2030",
    source: "Grand View Research",
    link: "https://www.grandviewresearch.com/industry-analysis/medical-imaging-systems-market",
    solution: "medical-imaging"
  },
  {
    stat: "15.9%",
    desc: "Global OCT market growth rate through 2030",
    source: "Grand View Research",
    link: "https://www.grandviewresearch.com/industry-analysis/optical-coherence-tomography-oct-market",
    solution: "medical-imaging"
  },
  {
    stat: "20%",
    desc: "Diagnostic interpretation accuracy improvement through OCT AI integration",
    source: "Heavy Reading",
    link: "https://www.heavyreading.com/",
    solution: "medical-imaging"
  },

  {
    stat: "80%",
    desc: "Of visual information is retained when sophisticated optics are used",
    source: "Venngage",
    link: "https://venngage.com/blog/human-brain-statistics/",
    solution: "neuroscience"
  },
  {
    stat: "30%",
    desc: "Resolution boost is achieved through advances in two-photon microscopy",
    source: "DOI",
    link: "https://doi.org/10.7554/eLife.101420",
    solution: "neuroscience"
  },
  {
    stat: ">90%",
    desc: "Light transmission efficiency is capable through custom GRIN lenses",
    source: "Inscopix",
    link: "https://inscopix.com/lenses-viruses/",
    solution: "neuroscience"
  }
];

export default factoids;